import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import backgroundLogin from 'assets/videos/teste.mp4';

interface PageLayoutProps {
  background?: 'white' | 'light' | 'default';
  children: ReactNode;
}

const PageLayoutComponent: React.FC<PageLayoutProps> = ({
  background = 'default',
  children,
}) => {
  const { pathname } = useLocation();

  return (
    <Box
      width="100vw"
      height="100vh"
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundColor: 'black',
          opacity: 0.7,
          zIndex: -90,
        }}
      ></Box>
      <video
        src={backgroundLogin}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          objectFit: 'cover',
          zIndex: -100,
        }}
        autoPlay
        loop
        muted
      />
      {children}
    </Box>
  );
};

export default PageLayoutComponent;
